import CoverImageCropper from './CoverImageCropper';

export default CoverImageCropper;
